import { render } from "./WebsiteFormLeads.vue?vue&type=template&id=0f15da05"
import script from "./WebsiteFormLeads.vue?vue&type=script&lang=js"
export * from "./WebsiteFormLeads.vue?vue&type=script&lang=js"

import "./WebsiteFormLeads.vue?vue&type=style&index=0&id=0f15da05&lang=css"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__